'use strict';

/**
 * Represents the cookie's 'SameSite' status:
 * https://tools.ietf.org/html/draft-west-first-party-cookies
 *
 * @export
 */
export type CookieSameSite = 'Strict' | 'Lax';
